const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  color: (lambdaParameter, value) =>
    `${lambdaParameter}.Color.Equals("${value}")`,
  deviceType: (lambdaParameter, value) =>
    `${lambdaParameter}.DeviceType.Contains("${value}")`,
  deviceId: (lambdaParameter, value) =>
    `${lambdaParameter}.Device.Id.Equals(${value})`,
  containerId: (lambdaParameter, value) =>
    `${lambdaParameter}.Container.Id.Equals(${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
